import { render, staticRenderFns } from "./_popin.vue?vue&type=template&id=568077cc&scoped=true&"
import script from "./_popin.vue?vue&type=script&lang=js&"
export * from "./_popin.vue?vue&type=script&lang=js&"
import style0 from "./_popin.vue?vue&type=style&index=0&id=568077cc&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "568077cc",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PageTitle: require('/opt/build/repo/components/PageTitle.vue').default,HeaderMedia: require('/opt/build/repo/components/HeaderMedia.vue').default,ApiContent: require('/opt/build/repo/components/ApiContent.vue').default,PeopleThumb: require('/opt/build/repo/components/PeopleThumb.vue').default})
